<template>
  <template v-if="operator">
    <!-- Fixed warning bar at top of every page -->
    <div
      class="fixed left-0 right-0 top-0 z-[9999] flex flex-col items-stretch gap-1 bg-danger-600 px-4 py-2 shadow-lg sm:flex-row sm:items-center sm:justify-between sm:gap-0"
      style="color: white"
    >
      <span class="text-sm font-bold">
        ⚠️ خرید به نمایندگی — در حال ثبت سفارش به جای: {{ user.contact?.fullName || user.userName }}
      </span>

      <button
        type="button"
        class="self-start rounded px-3 py-1 text-sm font-semibold hover:bg-danger-700 sm:ml-4 sm:self-auto"
        style="color: white; border: 1px solid white"
        @click="exitImpersonation"
      >
        خروج از نمایندگی
      </button>
    </div>

    <!-- Spacer so page content is not hidden under the fixed bar -->
    <div class="h-16 sm:h-10" />
  </template>
</template>

<script setup lang="ts">
import { useUser } from "@/shared/account";
import { useSignMeOut } from "@/shared/account/composables/useSignMeOut";

const { operator, user } = useUser();
const { signMeOut } = useSignMeOut();

async function exitImpersonation(): Promise<void> {
  await signMeOut();
}
</script>
